import { Injectable } from '@angular/core';
import { list } from '@daas-consulting/production/age_groups/frontend/models';
import { Selector } from '@ngxs/store';
import { AgeGroupsListState } from './age_groups-list.state';
import { AgeGroupsListStateModel } from './age_groups-list.state-model';

@Injectable()
export class AgeGroupsSelectors {
  @Selector([AgeGroupsListState])
  static items(state: AgeGroupsListStateModel): list.ItemView[] {
    return state.items;
  }
}
